import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

import type { StudyWorkflowStepMetric } from './studyWorkflowInventory';

interface WorkflowStepMetricsProps {
  metrics: StudyWorkflowStepMetric[];
}

export const WorkflowStepMetrics = ({ metrics }: WorkflowStepMetricsProps) => (
  <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
    {metrics.map(({ label, value }) => (
      <Stack key={label} spacing={0.1}>
        <Typography variant="h6" sx={{ lineHeight: 1.2 }}>
          {value}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
